export default __webpack_public_path__ + "static/media/fundo-rosa-home.283b0be9.png";